import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GrupoPaisFrService } from './grupopaisfr.service';
import { HttpParams } from '@angular/common/http';
import { GrupoPaisFrItemResultsViewModel, GrupoPaisFrViewModel } from './grupopaisfr.types';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-grupopaisfr-list',
    templateUrl: './grupopaisfr-list.component.html',
})
export class GrupoPaisFrListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    resultGruposPaisesFr: GrupoPaisFrItemResultsViewModel;
    cols: any[];
    visibilitySpinner: boolean = false;
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private grupopaisfrService: GrupoPaisFrService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultGruposPaisesFr = new GrupoPaisFrItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Descripcion', header: 'Nombre Grupo Países FR' },
        ];

        this.form = this.fb.group({
            Descripcion: '',
        });

        this.loadBack();
    }

    loadBack() {
        if (this.grupopaisfrService.currentFilterGrupoPaisFr.Descripcion != '') {
            this.form.patchValue({
                Descripcion: this.grupopaisfrService.currentFilterGrupoPaisFr.Descripcion,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.grupopaisfrService.currentFilterGrupoPaisFr.Descripcion = this.form.value.Descripcion;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('Descripcion', this.form.value.Descripcion);

        this.loading = true;
        this.grupopaisfrService.getGrupoPaisFrPagedByFilter(params).subscribe(result => {
            this.resultGruposPaisesFr = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Descripcion: '',
        });

        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onClone(item: GrupoPaisFrViewModel): void {
        //let params = new HttpParams();

        //params = params.append('id', item.Id.toString());

        //Diferenciamos por tipo de Solicitud, para clonar como NO previas con los incluidos en el IF y si es otro ejecutar el else escogiendo
        this.confirmationService.confirm({
            message:
                '¿Está seguro de clonar este Grupo de Países FR? Se clonarán los países asociados y podrá añadir o eliminar en el mantenimiento de "Países FR"',
            accept: () => {
                this.grupopaisfrService.cloneGrupoPaisFR(item.Id).subscribe({
                    next: res => {
                        this.addSuccessMessage('Solicitud clonada correctamente');
                        const idResult = res;
                        this.router.navigate(['/mantenimiento/frecuenciareducida/grupospaisesfr/edit', idResult]);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/frecuenciareducida/grupospaisesfr/create']);
    }

    onEdit(item: GrupoPaisFrViewModel) {
        this.router.navigate(['/mantenimiento/frecuenciareducida/grupospaisesfr/edit', item.Id]);
    }

    onDelete(item: GrupoPaisFrViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.grupopaisfrService.deleteGrupoPaisFr(item.Id).subscribe(res => {
                    this.addSuccessMessage('Grupo País FR eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    CreateModel() {
        let model: GrupoPaisFrViewModel = new GrupoPaisFrViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.grupopaisfrService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }
}
